import React, {useEffect, useState} from 'react';
import Container from "@mui/material/Container";
import ProductCard from "./productCard/ProductCard";
import {FormGroup, Grid2} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ProductsManager from "../../managers/productsManager/productsManager";
import {Trans, useTranslation} from "react-i18next";
import {getDatabase, onValue, ref} from "firebase/database";
import app from "../../firebaseConfig/firebaseConfig";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FilterAltOutlined from '@mui/icons-material/FilterAltOutlined';
import IconButton from "@mui/material/IconButton";

const db = getDatabase(app);
const categoriesRef = ref(db, 'categories');

function Products() {
    const limit = 40;
    const [products, setProducts] = useState([]);
    const [count, setCount] = useState();
    const [reachedBottom, setReachedBottom] = useState(false);
    const [categories, setCategories] = useState({});
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [filterOpen, setFilterOpen] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        onValue(categoriesRef, snapshot => {
            const categories = snapshot.val();
            setCategories(categories || {});
        });
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const countData = await ProductsManager.getValidProductsCountForSelectedItems(selectedCategories);
            const data = await ProductsManager.getValidProductsFromToLimit(null, limit, selectedCategories);
            setProducts(data);
            setCount(countData);
        };

        fetchData();
    }, []);

    useEffect(() => {
        const container = document.getElementById('container');
        const handleScroll = () => {
            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight;
            const clientHeight = container.clientHeight;

            if (scrollTop + clientHeight >= scrollHeight - 150) {
                setReachedBottom(true);
            }
        };

        container.addEventListener('scroll', handleScroll);

        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (reachedBottom) {
            if (count !== Object.keys(products).length) {
                getData();
            }
            setReachedBottom(false);
        }
    }, [reachedBottom]);

    const getData = async () => {
        const ids = Object.keys(products).sort();
        const data = await ProductsManager.getValidProductsFromToLimit(ids[ids.length - 1], limit, selectedCategories);
        setProducts(Object.assign(products, data));
    };

    const categoryChange = async (event, id) => {
        let newSelectedCategories = selectedCategories || [];
        if (event.target.checked) {
            newSelectedCategories.push(id);
        } else {
            newSelectedCategories = selectedCategories.filter(category => category !== id);
        }

        setSelectedCategories([...newSelectedCategories]);
        const countData = await ProductsManager.getValidProductsCountForSelectedItems(newSelectedCategories);
        const data = await ProductsManager.getValidProductsFromToLimit(null, limit, newSelectedCategories);
        setProducts(data);
        setCount(countData);
    };

    return (products &&
        <Container maxWidth="md">
            <Box pt={4} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant={'h6'}><Trans i18nKey={"header.Products"}/>:</Typography>
                <IconButton onClick={() => setFilterOpen(!filterOpen)}>
                    <FilterAltOutlined />
                </IconButton>
            </Box>

            {filterOpen && (
                <Box mb={3} p={2} border={1} borderRadius={2} borderColor="grey.300">
                    <Typography variant="subtitle1"><Trans i18nKey="category.label"/>:</Typography>
                    <FormGroup>
                        {Object.keys(categories).map(key => (
                            <FormControlLabel
                                key={key}
                                control={<Checkbox onChange={(e) => categoryChange(e, key)} checked={selectedCategories.indexOf(key) > -1}/>}
                                label={t(categories[key].label)}
                            />
                        ))}
                    </FormGroup>
                </Box>
            )}

            <Grid2 container spacing={3}>
                {Object.keys(products).sort().map(key =>
                    <Grid2 key={products[key].id} size={{md: 4, sm: 6, xs: 12}} height={400}>
                        <ProductCard product={products[key]}/>
                    </Grid2>)}
            </Grid2>
        </Container>
    );
}

export default Products;
